<script setup lang="ts">
const prefix = 'components.results.carbonEmissionTooltip';

withDefaults(
  defineProps<{
    dark?: boolean;
  }>(),
  {
    dark: false,
  },
);
</script>

<template>
  <div class="mb-2 mt-2">
    <div
      class="mb-4 text-xs leading-5"
      :class="{ 'text-text-inverse': dark, 'text-text-secondary-600': !dark }"
    >
      {{ $t(`${prefix}.description`) }}
    </div>

    <div
      class="text-xs leading-5"
      :class="{ 'text-text-inverse': dark, 'text-text-secondary-600': !dark }"
    >
      <NuxtLink
        :to="$t(`${prefix}.learnMoreUrl`)"
        target="_blank"
        class="underline hover:text-gray-300"
        >{{ $t(`${prefix}.learnMore`) }}</NuxtLink
      >{{ $t(`${prefix}.learnMoreSuffix`) }}
    </div>
  </div>
</template>
